import { Skeleton, Stack } from '@mui/material'

export default function HeaderSkeleton() {
  return (
    <>
        <Stack direction="row" spacing={2} >

            <Skeleton variant="rectangular" sx={styles.card} animation="pulse" />
            <Skeleton variant="rectangular" sx={styles.card} animation="pulse" />
            <Skeleton variant="rectangular" sx={styles.card} animation="pulse" />
            <Skeleton variant="rectangular" sx={styles.card} animation="pulse" />

        </Stack>
    </>
  )
}

const styles = {
    card: {
        flex: 1, 
        height: 120, 
        borderRadius: "4px", 
        backgroundColor: 'primary.light',
        // border: `.5px solid rgba(255, 255, 255, 0.1)`,
        border: `primary.main`,
    }
}